import { HubAction } from './hub.action';
import { Observable, Subject } from 'rxjs';

export class InfoWindowTextChangedAction extends HubAction {
    private infoWindowTextChangedSubject: Subject<{
        infoText: string;
        visibilityId: number;
    }> = new Subject();

    public static ACTION_NAME = 'InfoWindowTextChanged';

    constructor() {
        super(InfoWindowTextChangedAction.ACTION_NAME);
    }

    public action(infoWindowTextChangedDto: { senderAccountName: string; infoText: string; visibilityId: number }): void {
        this.infoWindowTextChangedSubject.next({
            infoText: infoWindowTextChangedDto.infoText,
            visibilityId: infoWindowTextChangedDto.visibilityId,
        });
    }

    public get infoWindowTextChanged$(): Observable<{
        infoText: string;
        visibilityId: number;
    }> {
        return this.infoWindowTextChangedSubject.asObservable();
    }
}
